import Head from "next/head";
import { components } from "@gwp/oicms-rendering-utils";
import dynamic from "next/dynamic";
import { log } from "../lib/utils/commons";
import initializeOIL from "../lib/InitializeOIL";
import initializeCSA from "../lib/initializeCSA";
import GdprProxyModal from "./gdpr-modal/GdprProxyModal";
import GeoipModal from "./geoip-modal/GeoipModal";
import GeoipModalCG from './geoip-modalCG/GeoipModalCG'

const { HeadContent } = components;

const GwpTracking = dynamic(() => import("./GwpTracking"), { ssr: false });
const CmAuthoringLib = dynamic(() => import("./CmAuthoringLib"), {
  ssr: false
});

export default function Layout({ children, metaData = {} }) {
  log.debug("Rendering Metadata for Layout : " + JSON.stringify(metaData));
  initializeOIL();
  initializeCSA(metaData.isCSAEnabled);
  return (
    <>
      <HeadContent metadata={metaData} Container={Head} log={log} />
      {"gdprProxyModal" in metaData && (
        <GdprProxyModal {...metaData.gdprProxyModal} />
      )}
      <div id="app">
        <div id="main" role="main">
          {children}
        </div>
      </div>
      {metaData.geoip === "Enabled" && <GeoipModal />}
      {metaData.geoIpModalCG?.includes(metaData.catalogRef?.id) && <GeoipModalCG />}
      {metaData.gwpTrackingEnabled && <GwpTracking />}
      {metaData.cmAuthoringLibEnabled && (
        <CmAuthoringLib
          slotWiseContentReplacementMap={metaData.slotWiseContentReplacementMap}
          cmAuthConfig={metaData.cmAuthConfig}
        />
      )}
      {metaData.gwpTrackingEnabled && (
        <GwpTracking apiKey={metaData.gwpContentAnalyticsTrackingApiKey} />
      )}

    </>
  );
}
